import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getDivision: EvokeAction<AppState, AppActions> = async store => {
  try {
    const division = await api.get("divisions");
    
    await store.update(state => {
      state.division = division;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getUserDivision: EvokeAction<AppState, AppActions> = async store => {
  try {
    const division = await api.get(`divisions/common`);
    
    await store.update(state => {
      state.userDivisions = division;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const updateDivision: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    const updateDivisions = await api.patch(
      `divisions/${id}`,
      {},
      values
    );
    console.log("updateDivision...",updateDivisions)

    // await store.update((state) => {
    //   if (state.departments !== undefined) {
    //     state.division[updateDivisions.id] = updateDivisions;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const divisionActions = {
  getDivision,
  getUserDivision,
  updateDivision
};
